const Connector = ({ isBelowMissingHigh }: any) => {
  const color = isBelowMissingHigh ? "red" : "#11C89B";
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        height: "64px",
        marginTop: "-6px",
        marginBottom: "-6px",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          width: "2px",
          backgroundColor: color,
          zIndex: 0,
        }}
      />

      <div
        style={{
          width: "18px",
          height: "18px",
          backgroundColor: "#FFFFFF",
          border: isBelowMissingHigh ? "2px solid red" : "2px solid #11C89B",
          borderRadius: "50%",
          zIndex: 2,
        }}
      />

      <div
        style={{
          width: "2px",
          height: "16px",
          backgroundColor: isBelowMissingHigh ? "red" : "#11C89B",
          opacity: isBelowMissingHigh ? 0.99999 : 0.6,
          marginTop: "0px",
        }}
      />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 24 24"
        stroke={isBelowMissingHigh ? "red" : "#11C89B"}
        strokeWidth="2"
        style={{
          marginTop: "12px",
          zIndex: 2,
        }}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
};

export default Connector;
